<template>
  <div class="dashboard-layout">
    <Header />
    <v-container class="my-4">
      <v-row>
        <v-col :lg="authUser && authUser.id ? 9 : 12" cols="12">
          <router-view></router-view>
        </v-col>
        <!-- Right Side -->
        <v-col v-if="authUser && authUser.id" lg="3" sm="12" cols="12">
          <RightSection />
        </v-col>
      </v-row>
    </v-container>
    <!-- <Footer /> -->
    <v-tour name="myTour" :steps="steps"></v-tour>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
import RightSection from "../rightsection/Index.vue";
import ProfileCard from "../ProfileCard.vue";
import { usersCollection } from "../../config/firebase";
export default {
  name: "DashboardLayout",
  data() {
    return {
      steps: [
        {
          target: "#search-bar", // We're using document.querySelector() under the hood
          header: {
            title: "Search Network",
          },
          content: `Search Users, Groups, Events, Featured User with Filter`,
        },
        {
          target: "#navigation", // We're using document.querySelector() under the hood
          header: {
            title: "Navigation",
          },
          content: `Navigate to different pages`,
        },
        {
          target: "#profile-card", // We're using document.querySelector() under the hood
          header: {
            title: "Profile Card",
          },
          content: `Basic Profile Detail`,
        },
        {
          target: "#payment-card", // We're using document.querySelector() under the hood
          header: {
            title: "Subscription Detail",
          },
          content: `Basic Subscription Detail`,
        },
      ],
    };
  },

  mounted() {
    if (
      !this.getLoggedUser().isTutorialSeen &&
      this.getLoggedUser().isCompleted
    ) {
      this.$tours["myTour"].start();
      usersCollection
        .doc(this.getLoggedUser().id)
        .update({ isTutorialSeen: true });
    }
  },
  watch: {
    authUser: function () {
      if (
        !this.getLoggedUser().isTutorialSeen &&
        this.getLoggedUser().isCompleted
      ) {
        this.$tours["myTour"].start();
        usersCollection
          .doc(this.getLoggedUser().id)
          .update({ isTutorialSeen: true });
      }
    },
  },
  components: {
    Footer,
    Header,
    RightSection,
    ProfileCard,
  },
};
</script>
<style scoped>
.dashboard-layout {
  background: #edf2f6;
  min-height: 100vh;
}
</style>